angular
    .module('app')
    .component('leadsEdit', {
        templateUrl: '/templates/pages/leads/leadsEdit/leadsEdit.html',
        controller: 'LeadsEditController',
        controllerAs: 'vm',
    });